/* eslint-disable @typescript-eslint/no-unused-vars */
import { Logger } from './logger';

export class SilentLogger implements Logger {
  info(value: any, ...rest: any[]): void {
    // does nothing
  }

  warn(value: any, ...rest: any[]): void {
    // does nothing
  }

  error(value: any, ...rest: any[]): void {
    // does nothing
  }
}
